import { BrokerTypes } from "../graphql/__generated__/globalTypes";
import _ from "lodash";
import { generateURlData } from "../utils";
import { parse } from "path";
import { urls } from "../constants";

export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export const dashboardGreeting = () => {
  const date = new Date();
  let hours = date.getHours();
  let status =
    hours < 12
      ? "morning"
      : hours <= 18 && hours >= 12
      ? "afternoon"
      : "evening";

  return status;
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case "CANCELLED":
    case "DELIVERY FAILED":
      return "red";
    case "COMPLETED":
    case "DELIVERED":
    case "PAYOUT READY":
    case "PICKED UP":
      return "green";
    case "PENDING":
    case "AWAITING CUSTOMER CONFIRMATION":
      return "yellow";
    case "PROCESSING":
    case "ORDER PACKED":
    case "CUSTOMER CONFIRMED":
      return "blue";
    case "OUT FOR DELIVERY":
      return "sky";
    default:
      return "gray";
  }
};

export const getFlexibleName = (accountName: string) => {
  const name = noteOptions.find((note) => note.value === accountName)?.label;
  return name;
};

export const noteOptions = [
  {
    label: "1st Quarter",
    value: "FIRSTQUARTER",
  },
  {
    label: "2nd Quarter",
    value: "SECONDQUARTER",
  },
  {
    label: "3rd Quarter",
    value: "THIRDQUARTER",
  },
  {
    label: "4th Quarter",
    value: "FOURTHQUARTER",
  },
];

const createColumns = (arr: any[], names: string[]) => {
  const obj: any = {};
  arr.forEach((el, id) => {
    obj[names[id]] = el;
  });
  return obj;
};

export const generateCombinationsColumns = (
  variations: any[],
  combinations: any[]
): any[] => {
  const columnNames = variations.map((el) => el.variation_name);
  const _combinations = combinations.map((el) =>
    createColumns(el, columnNames)
  );
  return _combinations;
};

export const randomSKUGen = (sku?: string): string => {
  return sku
    ? `${sku}-${Math.floor(Math.random() * 90000) + 10000}`
    : `${Math.floor(Math.random() * 90000) + 10000}`;
};

export function cartesian(...args: any[]) {
  var r: any[] = [],
    max = args.length - 1;
  function helper(arr: any[], i: number) {
    for (var j = 0, l = args[i]?.length; j < l; j++) {
      var a = arr.slice(0); // clone arr
      a?.push(args[i][j]);
      if (i === max) r.push(a);
      else helper(a, i + 1);
    }
  }
  helper([], 0);
  return r;
}

const orderStatus = [
  "pending",
  "supplier notified",
  "reseller confirmed",
  "awaiting customer confirmation",
  "customer confirmed",
  "hub pickup",
  "order packed",
  "picked up",
  "out for delivery",
  "delivered",
  "payout ready",
  "supplier unreachable",
  "customer unreachable",
  "out of stock",
  "rescheduled",
  "rejected on delivery",
  "returned after delivery",
  "delivery failed",
  "cancelled",
];

export const TendoOrderStatus = orderStatus.map((status) =>
  status.toUpperCase()
);

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const processUserGraphData = (data: (Record<string, any> | null)[]) => {
  const firstData = _.groupBy(data, "month");
  const monthlyData = months.map((el, idx) => {
    const data = _.get(firstData, idx + 1);
    return {
      name: el,
      GH: _.find(data, { country: "GH" })?.total ?? 0,
      NG: _.find(data, { country: "NG" })?.total ?? 0,
      ZA: _.find(data, { country: "ZA" })?.total ?? 0,
    };
  });
  // const itemsToReturn = [];
  // console.log(firstData);
  // for (const [key, value] of Object.entries(firstData)) {
  //   // console.log(key, value);
  //   const item = {
  //     name: key,
  //     GH: _.find(value, { country: "GH" })?.total ?? 0,
  //     NG: _.find(value, { country: "NG" })?.total ?? 0,
  //   };
  //   itemsToReturn.push(item);
  // }

  // console.log(itemsToReturn);

  return monthlyData;
};

export const getUrl = (
  data: any,
  endpoint: string,
  broker: BrokerTypes
): string => {
  const host = urls[broker];
  const url = `${host}/${endpoint}/${generateURlData(data)}`;
  // console.log("URL", data, url);
  return parseUrl(url, {
    defaultProtocol: "https",
    forceHttps: true,
  });
};

/**
 * Fixes common issues in a URL string.
 *
 * @param url - The URL to fix
 * @param options - Optional settings for fixing
 * @returns A cleaned, properly formatted URL string
 */
export function parseUrl(
  url: string,
  options?: {
    defaultProtocol?: "http" | "https";
    forceHttps?: boolean;
  }
): string {
  if (!url || typeof url !== "string") return "";

  const defaultProtocol = options?.defaultProtocol || "https";
  const forceHttps = options?.forceHttps || false;

  // Trim whitespace
  let fixed = url.trim();

  // Fix common typos or bad encodings
  fixed = fixed.replace(/\s+/g, ""); // remove inner spaces
  fixed = fixed.replace(/\\/g, "/"); // replace backslashes with forward slashes

  // Add protocol if missing
  if (!/^https?:\/\//i.test(fixed)) {
    fixed = `${defaultProtocol}://${fixed}`;
  }

  try {
    const urlObj = new URL(fixed);

    // Optionally force HTTPS
    if (forceHttps && urlObj.protocol !== "https:") {
      urlObj.protocol = "https:";
    }

    // Remove duplicate slashes (but not after protocol)
    urlObj.pathname = urlObj.pathname.replace(/\/{2,}/g, "/");

    return urlObj.toString();
  } catch (err) {
    console.warn("Invalid URL passed to fixUrl:", url);
    return "";
  }
}

const CURRENCY_UPDATES: Record<string, string> = {
  LE: "SLE",
  D: "GMD"
};

export const convertCurrency = (
  currencyCode: string | null | undefined
): string => {
  if (!currencyCode) return "";

  const upperCode = currencyCode.toUpperCase().trim();
  return CURRENCY_UPDATES[upperCode] || upperCode;
};
